
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { EISTaskSecurityFilterComponent } from "./view/generated/eistasksecurity/eistasksecurity-standard-filter/eistasksecurity-standard-filter.component";
import { EISTaskSecurityStandardSearchComponent } from "./view/generated/eistasksecurity/eistasksecurity-standard-search/eistasksecurity-standard-search.component";
import { EISTaskSecurityComponent } from "./shared/base/entity-component/generated/eistasksecurity-component.base";
import { EISTaskSecurityService } from "./shared/service/generated/eistasksecurity.service";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,    
        NgbModule,
        NgbCollapseModule 
      ],    
    declarations: [
        EISTaskSecurityFilterComponent,
        EISTaskSecurityStandardSearchComponent,
		EISTaskSecurityComponent 			         
    ],
    providers: [  
		EISTaskSecurityService
    ],
    exports:[
        EISTaskSecurityFilterComponent,
        EISTaskSecurityStandardSearchComponent 
    ]
  })
export class EISTaskSecuritySharedModule { 

    constructor(){}
  
}
